import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DateRangeProvider } from './contexts/DateRangeContext';
import { ChartInteractionProvider } from './contexts/ChartInteractionContext';
import { TabProvider } from './contexts/TabContext';
import { Header } from './components/molecules/Header/Header';
import { TabNav } from './components/molecules/TabNav/TabNav';
import { TabContent } from './features/tabs/TabContent';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TabProvider>
        <DateRangeProvider>
          <ChartInteractionProvider>
            <div className="App">
              <Header />
              <TabNav />
              <TabContent />

              <footer className="App-footer">
                <h3>Data Sources</h3>
                <p>Power outage data from Maritime Electric.</p>
                <p>Energy production, load, and import data from the Government of Prince Edward Island.</p>
                <p>Weather data from Environment and Climate Change Canada (MSC GeoMet).</p>
                <p>Solar radiation data from Open-Meteo.</p>
                <p>All data is collected and stored locally for historical analysis.</p>
              </footer>
            </div>
          </ChartInteractionProvider>
        </DateRangeProvider>
      </TabProvider>
    </QueryClientProvider>
  );
}
